// Static blog data used by BlogRoute. Currently empty — posts will be added later.
// New posts can also be added via the Supabase API; this file is the source of
// truth for evergreen, prerendered company posts.

export const BLOG_DATA = {};

export default BLOG_DATA;
